export const EXAMPLE_LABELS = ["Docs"];
